import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

export default class AccordionController extends Controller {
  static targets = ['item', 'trigger', 'panel', 'icon']

  toggle (event) {
    const trigger = event.currentTarget
    const itemId = trigger.dataset.accordionId
    const panel = this.panelTargets.find(p => p.dataset.accordionId === itemId)
    const icon = trigger.querySelector('[data-accordion-target="icon"]')

    if (panel) {
      panel.classList.toggle('hidden')
      if (icon) {
        icon.classList.toggle('rotate-180')
      }
      trigger.setAttribute('aria-expanded', !panel.classList.contains('hidden'))
    }
  }
}

stimulus.register('accordion', AccordionController)
